import {ViewerEnd} from '../../../../../../graphql/generated/types';
import {createQueryClient} from '../../../../../../reactQuery/createQueryClient';
import {useViewerEndQuery} from '../../../../../../wrapper/viewerWrapper';

export function updateCacheIsAlarmOn({
  seriesId,
  productId,
  isAlarmOn,
}: {
  seriesId: number;
  productId: number;
  isAlarmOn: boolean;
}) {
  const queryClient = createQueryClient();
  queryClient.setQueryData(
    useViewerEndQuery.getKey({seriesId, productId}),
    (prevData: ViewerEnd | undefined) => {
      if (!prevData) {
        return prevData;
      }
      return {
        ...prevData,
        alarmOn: isAlarmOn,
      };
    }
  );
}
